import { PaperClipOutlined } from '@ant-design/icons';
import { Select, SelectProps } from 'antd';
import { useEffect, useState } from 'react';
import { RoleLevel, getDomainAssignableRoleLevelsRole } from '../../apis/mgmt/api';


export function RoleSelect(props: 
  SelectProps<any> & {
  domainId?: string
}) {

  const [data, setData] = useState<RoleLevel[]>([]);
    
  const load = (domainId?: string) => {
    if (!domainId) {
      setData([]);
      return;
    }
    getDomainAssignableRoleLevelsRole({ domainId: domainId }).then((result) => {
      setData(result.data || []);
    });
  };

  const { domainId } = props;
  useEffect(() => { load(domainId); }, [domainId]);
  
  return (
    <Select
      {...props}
      placeholder={props.placeholder || "Role"}
      showSearch
      suffixIcon={ <PaperClipOutlined className="site-form-item-icon" />}
      filterOption={false}
      notFoundContent={null}
      options={(data).map((d) => ({
        value: d,
        label: d,
      }))}
    />
  );
};
